import React from 'react';
import { Accordion } from 'react-bootstrap-accordion'

const FAQ = (props) => {

    const data = props.data;

    return (
        <section className="tf-section faq" style={{ margin: '80px 0', padding: '60px 0' }}>
            <div className="container ">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center">
                            <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>PF</span></h1>
                            <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Preguntas Frecuentes</h5>
                            <h3 className="title mb-28 text-black" data-aos="fade-up" data-aos-duration="1000">Algunas <br /> Preguntas Frecuentes</h3>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="flat-accordion " data-aos="fade-up">
                            {
                                data.slice(0, Math.ceil(data.length / 2)).map((data, index) => (
                                    <Accordion className="h5 toggle-title" key={index} title={<span className="text-black" style={{ fontSize: 'calc(1em + 4px)' }}>{data.title}</span>} show={data.show}>
                                        <p className="fs-17 text-black">{data.text}</p>
                                    </Accordion>
                                ))
                            }
                        </div>
                    </div>
                    <div className="col-md-6 text-black">
                        <div className="flat-accordion" data-aos="fade-up">
                            {
                                data.slice(Math.ceil(data.length / 2)).map((data, index) => (
                                    <Accordion className="h5 toggle-title" key={index} title={<span className="text-black" style={{ fontSize: 'calc(1em + 4px)' }}>{data.title}</span>}>
                                        <p className="fs-17 text-black">{data.text}</p>
                                    </Accordion>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FAQ;